module.exports = {
  PROTOCOLS: ["udp", "tcp"] // Order is important, udp goes first
};



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/PortDefinitionConstants.js